const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.imageBackground,
}

export default imagesCarousel
